import styled from 'styled-components';

const IWGpageBackgroundColor = ({theme:{$iwgPageBackgroundColor}}) => `${$iwgPageBackgroundColor}`;
const IWGSessionStatusActiveTextColor = ({theme:{$iwgSessionStatusActiveTextColor}}) => `${$iwgSessionStatusActiveTextColor}`;
const IWGSessionStatusActiveDotColor = ({theme:{$iwgSessionStatusActiveDotColor}}) => `${$iwgSessionStatusActiveDotColor}`;
const IWGSessionStatusActiveSessionUserColor = ({theme:{$iwgSessionStatusActiveSessionUserColor}}) => `${$iwgSessionStatusActiveSessionUserColor}`;
const IMGSessionStatusInActiveTextColor = ({theme:{$iwgSessionStatusInActiveTextColor}}) => `${$iwgSessionStatusInActiveTextColor}`;
const IMGSessionStatusInActiveDotColor = ({theme:{$iwgSessionStatusInActiveDotColor}}) => `${$iwgSessionStatusInActiveDotColor}`;
const IMGGamesListEmptyColor = ({theme:{$iwgGamesListEmptyColor}}) => `${$iwgGamesListEmptyColor}`;

const S = {};

S.InstantWinGameWrapper = styled.div`
    padding: 15px;
    background-color: ${IWGpageBackgroundColor};
`

S.SessionInfo = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    font-weight: bold;

    & .dot {
        margin-right: 12px;
        border-radius: 12px;
        height: 12px;
        width: 12px;
    }

    &.active {
        color: ${IWGSessionStatusActiveTextColor};

        .dot {
            background-color: ${IWGSessionStatusActiveDotColor};
        }

        .session-user {
            color: ${IWGSessionStatusActiveSessionUserColor};
        }
    }

    &.inactive {
        color: ${IMGSessionStatusInActiveTextColor};
        .dot {
            background-color: ${IMGSessionStatusInActiveDotColor};
        }
    }
`


S.StyledInstantWinGamesList = styled.div`
    grid-template-columns: repeat(6, 1fr);
    display: grid;
    gap: 30px;
`

S.GamesListEmpty = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 14px;
    color: ${IMGGamesListEmptyColor};
`

export default S;